<div #formFieldContainer class="classGblMarkDown">
  <ng-container *ngIf="!componentDefinition.hideLabel">
    <mat-label
      #labelContainer (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>

    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
  </ng-container>
  <div class="guh-wrapper">
    <guh-editor
        #editorElement
        (change)="onChangeEvent($event)"
        hljsThemeHref="//unpkg.com/@highlightjs/cdn-assets@11.6.0/styles/github.min.css">
    </guh-editor>
    <mat-progress-bar *ngIf="uploading" [mode]="progressBarMode" [value]="progress"></mat-progress-bar>

  </div>

</div>
